// extracted by mini-css-extract-plugin
export default {"popper":"j_RxIU","fixedPositionPopper":"kkqxBC","seperator":"_YJt6T","closeButton":"cYbdir","files":"AS_dsw"};